import React, { createContext, useContext, useState } from "react";


export const AuthContext = createContext({} as AuthContextType);

type AuthContextProviderProps = {
  children: React.ReactNode
}

type AuthContextType = {

  UserToken: {
    token: string,
    refreshToken: string,
    expiry: string,
    LoggedInUserId: string,
    Roles: string[],
    Name: string,
    City: string,
    PhoneNumber: string,
    Email: string

  }
  // setHotelId : React.Dispatch<React.SetStateAction<string>>
  setUserToken: (
    token: string,
    refreshToken: string,
    expiry: string,
    LoggedInUserId: string,
    Roles: string[],
    Name: string,
    City: string,
    PhoneNumber: string,
    Email: string
  ) => void


}


export const AuthProvider = ({ children }: AuthContextProviderProps) => {


  let token_ = localStorage.getItem('Token');
  let refreshToken_ = localStorage.getItem('RefreshToken');

  
  let expiry_ = localStorage.getItem('Expiry');
  let loggedInUserId_ = localStorage.getItem('LoggedInUserId');
  console.log('*** ', localStorage.getItem('UserRoles'));

  let roles_ = [''];
  if (localStorage.getItem('UserRoles') !== null) {
    roles_ = Array.from(localStorage.getItem('UserRoles')!.split(','));
    console.log('previos roles == ', roles_);

  }

  // Array.from(localStorage.getItem('UserRoles')!.split(','));
  let Name_ = localStorage.getItem('Name');
  let City_ = localStorage.getItem('City');
  let PhoneNumber_ = localStorage.getItem('PhoneNumber');

  let email_ = localStorage.getItem('Email');



  const [UserToken, setUser_Token] = useState({
    token: token_ ? token_ : '',
    refreshToken: refreshToken_ ? refreshToken_ : '',    
    expiry: expiry_ ? expiry_ : '',
    LoggedInUserId: loggedInUserId_ ? loggedInUserId_ : '',
    Roles: roles_ ? roles_ : [''],
    Name: Name_ ? Name_ : '',
    PhoneNumber: PhoneNumber_ ? PhoneNumber_ : '',
    City: City_ ? City_ : '',
    Email: email_ ? email_ : ''

  })

  const setUserToken = (token: string, refreshToken: string, expiry: string, LoggedInUserId: string,
    Roles: string[], Name: string, City: string, PhoneNumber: string,
    Email: string) => {

    localStorage.setItem('Token', token);

    localStorage.setItem('RefreshToken', refreshToken);

    localStorage.setItem('Expiry', expiry);

    localStorage.setItem('LoggedInUserId', LoggedInUserId);

    localStorage.setItem('UserRoles', JSON.stringify(Roles));

    localStorage.setItem('Name', Name);
    localStorage.setItem('PhoneNumber', PhoneNumber);
    localStorage.setItem('City', City);

    localStorage.setItem('Email', Email);

    setUser_Token({
      token: token,
      refreshToken : refreshToken,
      expiry: expiry,
      LoggedInUserId: LoggedInUserId,
      Roles: Roles,
      Name: Name,
      City: City,
      PhoneNumber: PhoneNumber,
      Email: Email
    })

  }

  return (
    <AuthContext.Provider value={{ UserToken, setUserToken }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)

